import { useTranslation } from 'react-i18next';

import { formatValueWithK } from '../../../../../utils/helpers';
import { CHALLENGE_PROGRESS_BG } from '../../../constants';

import styles from './ChallengeProgressBar.module.scss';

interface ChallengeProgressBarProps {
  progressPercentage: number;
  target: number;
  current: number;
  extended?: boolean;
}

export function ChallengeProgressBar(props: ChallengeProgressBarProps) {
  const { extended, progressPercentage, target, current } = props;
  const { t } = useTranslation();
  return (
    <div className={extended ? styles.containerExtended : styles.container}>
      <img alt="" className={styles.img} src={CHALLENGE_PROGRESS_BG} />
      <div className={extended ? styles.progressBarContainerExtended : styles.progressBarContainer}>
        <div
          className={extended ? styles.progressExtended : styles.progress}
          style={{ width: `${progressPercentage}%` }}
        />
        <span className={extended ? styles.textExtended : styles.text}>
          {formatValueWithK(current, t)}/{formatValueWithK(target, t)}
        </span>
      </div>
    </div>
  );
}
